"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Directory/components/InfoBtn.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);
var _keyboard = require('web/services/keyboard');









const InfoBtn = ({
  label,
  iconSrc,
  theme,
  onClick,
  className,
}) => (
  _react2.default.createElement('div', {
    role: "button", tabIndex: 0, onKeyDown: _keyboard.onButtonKeyDown,
    onClick: onClick,
    className: _classBuilder2.default.call(void 0, 
      "team-page--info-btn",
      theme === 'danger' && "team-page--info-btn--danger",
      className,
    ), __self: this, __source: {fileName: _jsxFileName, lineNumber: 21}}

    , _react2.default.createElement('div', { className: "team-page--info-btn--icon", __self: this, __source: {fileName: _jsxFileName, lineNumber: 30}}
      , _react2.default.createElement('img', { src: iconSrc, alt: label, __self: this, __source: {fileName: _jsxFileName, lineNumber: 31}} )
    )
    ,  label 
  )
)

exports. default = InfoBtn
